import { Component } from '@angular/core';

@Component({
  selector: 'om-svg-copy-icon',
  templateUrl: './svg-copy-icon.component.html',
})
export class SvgCopyIcon {
  constructor() {}
}
